<template lang="pug">
div
  //- .mt-3.d-none.d-md-block
    .text-center
      //- iframe(src='https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fepicwinphilippines&tabs&width=1100&height=150&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId' width='1100' height='150' scrolling='no' frameborder='0' allowfullscreen='allowfullscreen' allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share' style='border: none; overflow: hidden;')
      iframe(src='https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fepicwinplusph&tabs&width=500&height=130&small_header=false&adapt_container_width=false&hide_cover=false&show_facepile=false&appId' width='500' height='130' style='border:none;overflow:hidden' scrolling='no' frameborder='0' allowfullscreen='true' allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share')
  //- .mt-3.d-md-none
    .text-center
      iframe(src='https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fepicwinplusph&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=false&appId' width='340' height='130' style='border:none;overflow:hidden' scrolling='no' frameborder='0' allowfullscreen='true' allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share')
  .comm
    h3 {{$t('ui.follow_us')}}
    .comm-c(v-if="getViber!=='' || getTgLink!=='' || getIg!=='' || getYt!==''")
      a.c1(v-if="getViber!==''" :href="getViber" target="_blank")
        i.fa-brands.fa-viber
        |  Viber
      a.c2(v-if="getTgLink!==''" :href="getTgLink" target="_blank")
        i.fa-solid.fa-paper-plane
        |  Telegram
      a.c3(v-if="getIg!==''" :href="getIg" target="_blank")
        i.fa-brands.fa-instagram
        |  Instagram
      a.c4(v-if="getYt!==''" :href="getYt" target="_blank")
        i.fa-brands.fa-youtube
        |  youtube
  .comm.mt-3
    h3 {{$t('ui.our_partner')}}
    .comm-c2
      template(v-if="$helpers.timingFilter('2025-11-01 00:00')")
        img.comm-img.pointer(src="/new/img/partnership/home/JBW-Lucky Spin Holiday Edition.png" @click="openLink('https://jilibetph.win/RF12259A28')")
        //- img.comm-img.pointer(src="/new/img/partnership/home/b-okbet.png" @click="openLink('https://okbet23.ph/RF1A327930')")
        img.comm-img.pointer(src="/new/img/partnership/home/Maya-Golden Egg Holiday Edition.png" @click="openLink('https://maya23.ph/RF1A328023')")
        img.comm-img.pointer(src="/new/img/partnership/home/GCash-Scratch & Win Holiday Edition.png" @click="openLink('https://gcash23.ph/RF15782682')")
      template(v-else)
        img.comm-img.pointer(src="/new/img/partnership/home/b-jbw.png" @click="openLink('https://jilibetph.win/RF12259A28')")
        //- img.comm-img.pointer(src="/new/img/partnership/home/b-okbet.png" @click="openLink('https://okbet23.ph/RF1A327930')")
        img.comm-img.pointer(src="/new/img/partnership/home/b-maya.png" @click="openLink('https://maya23.ph/RF1A328023')")
        img.comm-img.pointer(src="/new/img/partnership/home/b-gcash.png" @click="openLink('https://gcash23.ph/RF15782682')")
</template>
<script>
export default{
  computed:{
    getTgLink(){
      if(this.$store.getters.getSocialList.length> 0){
        for(var x = 0; x < this.$store.getters.getSocialList.length; x++){
          if(this.$store.getters.getSocialList[x].social_platform === 'telegram'){
            return this.$store.getters.getSocialList[x].social_link
          }
        }
        return ""
      }else{
        return ""
      }
    },
    getViber(){
      if(this.$store.getters.getSocialList.length> 0){
        for(var x = 0; x < this.$store.getters.getSocialList.length; x++){
          if(this.$store.getters.getSocialList[x].social_platform === 'viber'){
            return this.$store.getters.getSocialList[x].social_link
          }
        }
        return ""
      }else{
        return ""
      }
    },
    getYt(){
      if(this.$store.getters.getSocialList.length> 0){
        for(var x = 0; x < this.$store.getters.getSocialList.length; x++){
          if(this.$store.getters.getSocialList[x].social_platform === 'youtube'){
            return this.$store.getters.getSocialList[x].social_link
          }
        }
        return ""
      }else{
        return ""
      }
    },
    getIg(){
      if(this.$store.getters.getSocialList.length> 0){
        for(var x = 0; x < this.$store.getters.getSocialList.length; x++){
          if(this.$store.getters.getSocialList[x].social_platform === 'instagram'){
            return this.$store.getters.getSocialList[x].social_link
          }
        }
        return ""
      }else{
        return ""
      }
    },
  },
  methods:{
    openLink(target){
      window.open(target, "_blank")
    }
  }
}
</script>